import React from 'react';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { useStyles } from './ConnectUrbanSports.styles';
import { IdListCard } from '../Card/IdListCard';
import { TokenListCard } from '../Card/TokenListCard';
import { useUSCConnectContext } from './UrbanSportsConnectContext';

export const ConnectUrbanSports = () => {
  const { classes } = useStyles();

  const { error, saveClicked, setSaveClicked, dates } = useUSCConnectContext();

  const saveIntegration = () => {
    setSaveClicked(true);
  };

  const { startDate } = dates;

  return (
    <PrivateLayout
      title="Connect Integration"
      actionName="Save"
      onActionTaken={saveIntegration}
      actionDisabled={saveClicked && startDate !== '' && !error}
    >
      <div className={classes.container}>
        <IdListCard />
        <TokenListCard />
      </div>
    </PrivateLayout>
  );
};
